// Slide decks associated with Software Engineering (SE) sprint 5
import { xyz_n_1of4, xyz_n_2of4, xyz_n_MidtermExam, xyz_n_MidtermExam_PAaA, xyz_n_4of4_PAaA, xyz_n_4of4 } from './SL00000Sprint00TTR'
import { insertInto, sprintPlanningSlideDeck } from './SLSprintPlanning'
import { orderedListSlide, submissionPercentage } from './SLSprint00'

import { list44000Sprint04 } from '../ActivityLists/AL44000Sprint04'
import { list44000Sprint05 } from '../ActivityLists/AL44000Sprint05'

const sprint = 5
const activityList = () => { return list44000Sprint05(sprint) }
const activityListPrevious = () => { return list44000Sprint04(sprint-1) }
const sprintAndActivityLists = { 'sprint': sprint, 'activityList': activityList, 'activityListPrevious': activityListPrevious }

// Session 1 of 4: Tuesday
export const sprintPlanningExpectations = () => {
		return orderedListSlide('Sprint Planning', `Sprint ${sprint} Expectations:`, [
			'Similar to other sprints with Discussion, Lab, and Reflection',
			'Different in that we will have our Midterm Exam in class next Tuesday with in-person attendance required',
			`Similar in that we will have two weeks to complete all sprint ${sprint} assignments`,
			`Similar in that we will have sprint ${sprint-1} Demos and Retrospectives on Thursday`,
			`Similar in that we will complete on Discussion Board ${sprint} as a scrum team in class on Thursday`,
			'Very different in that you will be performing sprint planning for your team and your team’s product', 
	])
}
const se_5_1of4_PAaA = { 
	'prework':[ 
		'Everything due Sunday!', '',
		`Be prepared for Sprint ${sprint} Planning` ],
	'announcements':[ 
		`Sprint ${sprint} starts now` ],
	'agenda':[ 
		`Sprint ${sprint} Planning for our Class`,
		`Sprint ${sprint} Planning for your Product and Team` ]
}

const se_5_1of4 = () => {
	const slideDeck =  xyz_n_1of4(se_5_1of4_PAaA, null, sprintAndActivityLists, sprintPlanningExpectations)
	const recapSlide = 9
	const slideDeckWithPlanning =  insertInto(slideDeck, sprintPlanningSlideDeck(sprint), recapSlide)
	return slideDeckWithPlanning
}

// Session 2 of 4: Thursday
const se_5_2of4_PAaA = {
	'prework':[
		'Complete through activity 5 prior to next class', '',
		`Be prepared Discussion Board ${sprint}`,
		'Be prepared for Sprint Planning (continued)' ],
	'announcements':[ 
		'Reminder that next Tuesday is our Midterm Exam with in-person attendance required**',
		`Sprint ${sprint} Planning Due today!` ],
	'agenda':[
		`Sprint ${sprint-1} Demos`,
		`Sprint ${sprint-1} Retrospective`,
		`Breakout for Sprint ${sprint-1} Retrospective`,
		`Sprint ${sprint} Planning Q&A`,
		`Discussion Board ${sprint} as a scrum team`,
		'Prework for Next Class', 
		`Lab: Sprint ${sprint} Planning (continued)`, ]
}
const se_5_2of4 = () => {
	const metricsSubmissionPercentage = () => {
		return submissionPercentage([
			{ name: 'Discussion', due:19, submitted:18 },
			{ name: 'Quiz', due:19, submitted:16 },
			{ name: 'Lab', due:19, submitted:18 },
			{ name: 'Reflection', due:19, submitted:16 }])
	}
	const retrospective = () => {
		return orderedListSlide('Class Retrospective',
			'Feedback from Assignments & Reflections', [
			`Discouraging submission percentage in sprint ${sprint-1}`,
			'I’m always confused at why not setting aside quiz time in class results in multiple quizzes not being submitted.', 
			'Some Lab and Reflection assignments not graded/posted', 
			`If you are not where you want to be in the class after sprint ${sprint-1}, we need to talk immediately.`,
			`If you are not where you want to be in the class, you should consider dropping` ])
	}
	const slideDeck = xyz_n_2of4(se_5_2of4_PAaA, se_5_3of4_PAaA, sprintAndActivityLists, metricsSubmissionPercentage, retrospective)
	const insertAfter = 16
	const slideDeckWithPlanning =  insertInto(slideDeck, sprintPlanningSlideDeck(sprint), insertAfter)
	return slideDeckWithPlanning
}

// Session 3 of 4: Tuesday
const se_5_3of4_PAaA = xyz_n_MidtermExam_PAaA(sprint)
const se_5_3of4 = () => { return xyz_n_MidtermExam(se_5_3of4_PAaA, se_5_4of4_PAaA, sprintAndActivityLists) }

// Session 4 of 4: Thursday
const se_5_4of4_PAaA = xyz_n_4of4_PAaA('Complete through activity 5', sprint)
const se_5_4of4 = () => { return xyz_n_4of4(se_5_4of4_PAaA, null, sprintAndActivityLists ) }

export const se_5_slidedeckTTR = [ se_5_1of4, se_5_2of4, se_5_3of4, se_5_4of4 ]